import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import EZRentToOwnCompo from "../components/EZRentToOwnCompo.jsx";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
const EZRentToOwn = () => {
  return (
    <>
      <SEO
        title="EZ Rent to Own | Affordable Business Vehicle Leasing Melbourne, Victoria"
        description="EZ Rent to Own - Affordable business vehicle leasing in Melbourne, Victoria, Australia. No credit checks required. Own your vehicle with weekly payments from $195. Perfect for tradies, delivery drivers, and small businesses."
        keywords="rent to own Melbourne, business vehicle leasing Victoria, no credit check car rental Australia, vehicle leasing Melbourne, business car rental Victoria, tradie vehicle rental Melbourne, delivery driver car rental Australia, affordable vehicle leasing Melbourne"
        url="https://ezcarrentals.com.au/ezrent-to-own"
      />
      <StructuredData type="organization" />
      <Navbar />
      <EZRentToOwnCompo />
      <Footer />
    </>
  );
};

export default EZRentToOwn;
